import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
/*App imports*/
import { HelpersService, EstatusCreditos, TiposCreditos } from '../../../services/tools/helpers.service';
import { PagosService } from '../../../services/pagos.service';
import { AgregarPagoComponent } from './components/agregar-pago/agregar-pago.component';
import { CreditosService } from "../../../services/creditos.service";
import { AutenticacionService } from '../../../services/autenticacion.service';
import { Router } from '@angular/router';

@Component({
  selector: 'tabla-pagos',
  templateUrl: './tabla-pagos.component.html'
})
export class TablaPagosComponent implements OnInit {

    @Input() public idCreditos: number = null;
    @ViewChild('agregarPago') agregarPago: AgregarPagoComponent;

    public tablaPagos: any[] = [];
    public errors: any = {};
    public isValidShowPagos: boolean = false;
    public isValidToAddPago: boolean = false;
    public isCreditoMeses: boolean = false;
    public isExecutive : boolean = false;
    public waitingResponse : boolean = false;

    constructor(
      private helperService: HelpersService,
      private pagosService: PagosService,
      private creditosService: CreditosService,
      private autenticacionService : AutenticacionService
    ){
    }

    ngOnInit() {
      this.isExecutive = this.autenticacionService.isExecutive();
    }

    public ngOnChanges(changes: SimpleChanges) {
      if (changes.idCreditos && this.idCreditos) {
        this.reloadTablaPagos();
        //this.getCredito(this.idCreditos);
      }
    }

    private getTablaPagos(idCredito: number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.pagosService.getTablaPagos(idCredito).subscribe(
        (response)=>
        {
          this.tablaPagos = response.json().content;
          console.log("Tabla de pagos: ",this.tablaPagos);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private getCredito(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.creditosService.get(idCreditos).subscribe(
          (response)=>
          {
          const credito = response.json().content;

          if(credito.idTipos_Creditos === TiposCreditos.MesesSinIntereses){
            this.isCreditoMeses = true;
          }
  
          //Solo se pueden agregar pagos a los créditos vigentes
          switch(credito.statusCredito ){
            case EstatusCreditos.Vigente:
              this.isValidShowPagos = true;
            break;
            case EstatusCreditos.Borrador:
            case EstatusCreditos.Pendiente:
              this.isValidShowPagos = false;
              break;
            case EstatusCreditos.Finalizado:
              this.isValidShowPagos = true;
              break;
          }

          this.isValidToAddPago = (credito.statusCredito === EstatusCreditos.Vigente);
          
          }, error =>
          {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          }
      );
    }

    public reloadTablaPagos(){
      this.getCredito(this.idCreditos);
      this.getTablaPagos(this.idCreditos);
    }

    public showPago(event: any, pago: any){
      this.agregarPago.showModalPago(pago.idPago);
    }

    public descargarRecibo(pago : any){
      this.waitingResponse = true;
      let url = encodeURIComponent(window.location.href);
      this.pagosService.getReciboPago(pago.idPago, url).subscribe(
        (response) => {
          this.generarArchivo(response, "pago_"+pago.idPago);
          this.waitingResponse = false;
        }, (error) => {
          this.helperService.httpGlobalError(error);
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          this.waitingResponse = false;
        }
      );
    }

    private generarArchivo(response, filename){
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      let newBlob = new Blob([response._body], {type: 'application/pdf'})
    
      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob)
      //   return
      // }
    
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob)
      window.open(data);
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data)
      }, 100)
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/tabla-pagos/tabla-pagos.component.ts